{
  "Panel Email": "Panel Email",
  "directadmin_email": {
    "0 = Sınırsız": "0 = Unlimited",
    "Disk Kullanımı": "Disk Usage",
    "Doluluk (%)": "Occupancy (%)",
    "E-posta Adresi": "E-mail Address",
    "E-posta Hesapları": "Email Accounts",
    "E-posta hesabı oluşturuldu": "Email account created.",
    "En az 6 karakter": "At least 6 characters",
    "Hesap silindi": "Account deleted.",
    "Hiç e-posta hesabı bulunamadı": "No email account found.",
    "Kota (0 = Sınırsız)": "Quota (0 = Unlimited)",
    "Kota (MB)": "Quota (MB)",
    "Kota Düzenle": "Edit Quota",
    "Kota Limiti (MB)": "Quota Limit (MB)",
    "Kota güncellendi": "Quota updated.",
    "Kullanıcı Adı": "Username",
    "Kullanım (MB)": "Usage (MB)",
    "Limit (MB)": "Limit (MB)",
    "Panel Email": "Panel Email",
    "Silme işlemi başarısız": "Deletion failed.",
    "Yeni E-posta Hesabı": "New Email Account",
    "Yeni Hesap": "New Account",
    "hesabı kalıcı olarak silinecek!": "account will be permanently deleted!",
    "için Yeni Şifre": "New Password for",
    "orn: info": "ex: info",
    "Şifre başarıyla değiştirildi": "Password changed successfully.",
    "Şifre en az 6 karakter olmalıdır": "Password must be at least 6 characters",
    "Bir hata oluştu": "Bir hata oluştu.",
    "Excel hatası: ": "Excel error: ",
    "Kullanıcı": "User",
    "Şifre Değiştir": "Change Password",
    "Sil": "Delete",
    "İptal": "Cancel",
    "Kaydet": "Save",
    "Oluştur": "Create",
    "Silme Onayı": "Delete Confirmation",
    "Hayır": "No",
    "Evet, Sil": "Yes, Delete",
    "Değiştir": "Change",
    "ExceleAktar": "Export to Excel",
    "Yükleniyor": "Loading...",
    "Şifre": "Password",
    "Yeni Şifre": "New Password",
    "Güncelle": "Update",
    "Emin misiniz?": "Are you sure?",
    "Hata oluştu": "Error occurred",
    "İşlemler": "Actions"
  }
}
